module.exports = __webpack_public_path__ + "img/h_logo_online_sp.78604b28.png";